/* eslint-disable import/no-extraneous-dependencies */
/* eslint no-underscore-dangle: ["error", { "allow": ["__svg__", "__svgstore__"] }] */
/* global globals */
import 'core-js/stable';
import 'regenerator-runtime/runtime';
import 'isomorphic-fetch';
//
import Bugsnag from '@bugsnag/js';
import BugsnagPluginReact from '@bugsnag/plugin-react';
//
import legacy from './legacy/main';
import ads from './app/ads';
import cookieConsentExtended from './helpers/cookieConsentExtended';

import '../../sass/main.scss';
// import geolocation from './app/geolocation';

//
const ignorePatterns = [
  'ResizeObserver loop limit exceeded',
  'ResizeObserver loop completed with undelivered notifications',
];
Bugsnag.start({
  apiKey: '369b008f4b772a462c218a0b6f8ed23c',
  plugins: [new BugsnagPluginReact()],
  appVersion: '1.3.1',
  releaseStage: globals.environment,
  enabledReleaseStages: ['production'],
  logger: null,
  onError: (event) => {
    if (ignorePatterns.some((re) => event.errors[0].errorMessage.includes(re))) {
      return false;
    }
    return true;
  },
});

let __svgstore__ = {
  path: './../../assets/img/svg/raw/**/*.svg',
  name: 'svg/inline-main.svg',
};
// https://github.com/mrsum/webpack-svgstore-plugin/issues/156
// TODO: change to be able to use [hash] in filename
__svgstore__ = {
  filename: 'static/svg/inline-main.svg',
};

require('webpack-svgstore-plugin/src/helpers/svgxhr')(__svgstore__);

console.logText = (text, background, color) => {
  console.log(`%c${text}`, `background: ${background || 'black'}; color: ${color || 'white'}; display: block; padding: 2px 4px;`);
};

const init = () => {
  legacy.init();
  ads.init();
  cookieConsentExtended.init();
  // geolocation.init();
};
init();
